var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.displayed)?_c('div',{staticClass:"options-popover"},_vm._l((_vm.options),function(ref,index){
var label = ref.label;
var color = ref.color;
return _c('ui-button',{key:(label + "-" + index),staticClass:"options-popover__button",style:({ color: color || 'black' }),attrs:{"button":"secondary","label":label},on:{"click":function($event){return _vm.onClickOption($event, index)}}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }